/**
 * Plugin information page
 * this page is a simple copy of the customize-react.js page. the only change is this page input fields are read only
 */

import { useState, createRoot, StrictMode } from "@wordpress/element";
import {__} from "@wordpress/i18n";
import domReady from "@wordpress/dom-ready";
import Heading from "./react-components/heading/Heading.jsx";
import TabPreview from "./react-components/previewTab/TabPreview.jsx";
import Message from "./react-components/message/Message.jsx";
import IconSection from "./react-components/iconSection/IconSection.jsx";
import MusicSection from "./react-components/musicSection/MusicSection.jsx";

const TabRecall = () => {
    const uploaderNonce = tabrecall_react.uploader_nonce;
    const imgDir = tabrecall_react.img_dir;
    const musicDir = tabrecall_react.music_dir;
    const prevData = tabrecall_react?.prev_data;
    const prevMessages = prevData?.messages ?? ["You may missing something"];
    const prevIcons = prevData?.icons ?? [imgDir + "img_pre.png"];
    const prevMusics = prevData?.musics ?? [musicDir + "ping.mp3"];
    const isEnabled = String(tabrecall_react?.prev_data?.enabled).toLowerCase() === 'true';

    const defaultIcons = [
        {"url" : imgDir + "img_pre.png", "uploading" : false, "selected": false},
        {"url" : imgDir + "img_pre_2.png", "uploading" : false, "selected": false},
    ];
    const defaultMusics = [
        {"url" : musicDir + "ping.mp3", "title" : "Static Demo Audio 1", "uploading" : false, "selected": false, "playing" : false},
        {"url" : musicDir + "ping2.mp3", "title" : "Static Demo Audio 2", "uploading" : false, "selected": false, "playing" : false},
    ];

    /**
     * get all previous icons for state
     */
    const savedIconState = [];

    // For each URL in saved array
    prevIcons.forEach(savedUrl => {
    // Create a deep copy of defaultIcons
    const iconsCopy = JSON.parse(JSON.stringify(defaultIcons));
    
    // Try to find a matching URL in our copy
    let found = false;
    for (let icon of iconsCopy) {
        const defaultFilename = icon.url;
        const savedFilename = savedUrl;
        
        if (defaultFilename === savedFilename) {
            // If we find a match, set selected to true
            icon.selected = true;
            found = true;
            break;
        }
    }
    
    // If no match found, add the new item to the copy
    if (!found) {
        iconsCopy.push({
        url: savedUrl,
        uploading: false,
        selected: true
        });
    }
    
    // Add this modified copy to our savedIconState
    savedIconState.push(iconsCopy);
    });

    /**
     * get all previous icons for state
     */
    const savedMusicState = [];

    // For each URL in saved array
    prevMusics.forEach(savedUrl => {
        // Create a deep copy of defaultIcons
        const musicsCopy = JSON.parse(JSON.stringify(defaultMusics));
        
        // Try to find a matching URL in our copy
        let found = false;
        let a = 1;
        for (let music of musicsCopy) {
            const defaultFilename = music.url;
            const savedFilename = savedUrl;
            
            if (defaultFilename === savedFilename) {
                // If we find a match, set selected to true
                music.selected = true;
                found = true;
                let a = 2;
                break;
            }
        }
        
        // If no match found, add the new item to the copy
        if (!found) {
            musicsCopy.push({
            url: savedUrl,
            title: savedUrl,
            uploading: false,
            selected: true,
            playing: false
            });
        }
        
        // Add this modified copy to our savedMsgState
        savedMusicState.push(musicsCopy);
    });


    /**
     * set states here
     */
    const [messages, setMessages] = useState(prevMessages);
    const [tabMessages, setTabMessages] = useState([""]);
    const [icons, setIcons] = useState(savedIconState);
    const [musics, setMusics] = useState(savedMusicState);
    const [enabled, setEnabled] = useState(isEnabled);
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: "success",
    });
    const [delays, setDelays] = useState({
        message: prevData?.delays?.message ?? 1000,
        icon: prevData?.delays?.icon ?? 1000,
        music: prevData?.delays?.music ?? 1000,
    });

    const removeIconField = (index) => {
        const updatedIcons = [...icons];
        updatedIcons.splice(index, 1);
        setIcons(updatedIcons);
    };

    const addMessageField = () => {
        if(messages.length >= 3) {
            sweetAlert("You can only add 3 message.", "error");
            return;
        }
        setMessages([...messages, ""]);
    };
    const sweetAlert = (message, type) => {
        setAlert({
            show: true,
            message: message,
            type: type,
        });

        setTimeout(() => {
            setAlert({
                show: false,
                message: "",
                type: "success",
            });
        }
        , 3000);
    }

    return (
        <>
            <div className="tabrecall_app">
                <br />
                <br />
                <section>
                    <Heading 
                        enabled = {enabled}
                        headingText = "TabRecall"
                        enableText = "TabRecall Enabled?"
                    />
                </section>

                <section style={{
                filter: enabled ? "none" : "blur(5px)",
                pointerEvents: enabled ? "auto" : "none",
                
            }}>
                    <TabPreview
                    messages = {messages}
                    icons = {icons}
                    delays = {delays}
                    imgDir = {imgDir}
                    enabled = {enabled}
                     />
                </section>

                <form>
                    <div className="tabrecall_app_inner" style={{filter: enabled ? "none" : "blur(5px)",
                                pointerEvents: enabled ? "auto" : "none",}}>
                        <Message
                            messages={messages}
                            addMessageField={addMessageField}
                            imgDir={tabrecall_react.img_dir}
                            tabMessages = {tabMessages}
                            setTabMessages = {setTabMessages}
                            delay={delays.message}
                        />
                        <IconSection
                            icons={icons}
                            defaultIcons={defaultIcons}
                            removeFileField={removeIconField}
                            imgDir={tabrecall_react.img_dir}
                            sweetAlert={sweetAlert}
                            delay={delays.icon}
                            uploaderNonce={uploaderNonce}
                        />
                        <MusicSection
                            imgDir={tabrecall_react.img_dir}
                            musicDir={tabrecall_react.music_dir}
                            musics={musics}
                            setMusics={setMusics}
                            defaultMusics={defaultMusics}
                            sweetAlert={sweetAlert}
                            delay={delays.music}
                            uploaderNonce={uploaderNonce}
                            isPreview={true}
                        />
                    </div>

                    <div className="container submit_btn_container">
                        <a className="submit_btn" href={tabrecall_react?.customize_page}>Edit</a>
                    </div>
                </form>

                <br />
                <br />
                {
                    alert.show && (
                        <div id="snackbar-alert" style={{
                            backgroundColor: alert.type === "success" ? "#4CAF50" : "#f44336"
                        }}>{alert.message}</div>
                    )
                }
            </div>
        </>
    );
};

domReady(() => {
    const root = createRoot(
        document.getElementById("tabrecall_tabrecall_page_root"),
    );

    root.render(
        <StrictMode>
            <TabRecall />
        </StrictMode>
    );
});
